import { Activity } from '@components/Activity/Activity'
import { useAppDispatch } from '@hooks/redux'
import { RoutePaths } from '@interfaces/routePaths'
import {
  clearBreadcrumbs,
  setActionsButton,
  setActiveSection,
  setInviteButton,
} from '@redux/site/siteSlice'
import { useEffect } from 'react'

export const Base = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Activity'))
    dispatch(clearBreadcrumbs())
    dispatch(setInviteButton(false))
    dispatch(setActionsButton(false))
  })

  return (
    <Activity
      fullWidth
      state={{
        history: [
          {
            title: 'Activity',
            href: RoutePaths.ACTIVITY,
          },
        ],
      }}
    />
  )
}
